const datePickerSingles = document.querySelectorAll('.date-picker-single');

datePickerSingles.forEach((item) => {
  const initElem = item.querySelector('input');

  flatpickr(initElem, {
    dateFormat: 'd.m.Y',
    locale: localData?.calendar?.locale || flatpickr.l10ns.sl,
  });
});
